import { APP_BRAND_NAME, CREATE_AI_CREATION_PATH, DRAMA_PLAY_PATH_PREFIX, FEATURED_PATH, isAiLivePath, LIVE_PATH, RECOMMEND_PATH, WATCH_PATH_PREFIX } from "@/constants/appChrome";
import { dict, type MsgKey } from "@/i18n/strings";
import { useLocaleStore } from "@/store/locale";

/** 前台静态路径对应的浏览器标题文案 */
const ROUTE_TITLE_KEYS: Record<string, MsgKey> = {
  "/inspiration": "navInspiration",
  [FEATURED_PATH]: "navFeatured",
  [RECOMMEND_PATH]: "navForYou",
  "/drama": "navDrama",
  "/resource": "navAssetLibrary",
  [LIVE_PATH]: "navLive",
  "/following": "navFollowing",
  "/me": "navMe",
  "/orders": "navOrders",
  "/me/profile": "profileInfo",
  "/me/bean-records": "beanLedger",
  "/me/commission": "commissionTitle",
  "/me/payment": "payTitle",
  "/me/membership": "memberTitle",
  "/me/tiers": "tierTitle",
  "/me/seats": "seatsTitle",
  "/admin/training": "navTraining",
  "/admin/commission": "navCommission",
  "/admin/benefits": "navBenefits",
  "/pricing": "rechargeBeans",
  "/create": "navCreate",
  [CREATE_AI_CREATION_PATH]: "navCreate",
  "/profile": "profileCenter",
};

/**
 * 带参路径用前缀匹配。守卫拿到的是真实路径（如 `/watch/72`），对不上路由模板。
 */
function titleKeyForPath(path: string): MsgKey | undefined {
  const exact = ROUTE_TITLE_KEYS[path];
  if (exact) return exact;
  if (path.startsWith(WATCH_PATH_PREFIX)) return "titleWatchDetail";
  if (path.startsWith(DRAMA_PLAY_PATH_PREFIX)) return "titleDramaPlay";
  if (path === `${LIVE_PATH}/operators`) return "liveOperators";
  if (isAiLivePath(path)) return "navLive";
  return undefined;
}

/**
 * 按当前语言写入浏览器标题。
 * 路由守卫在登录校验前后都会调用，避免异步结束后把标题写回 meta 里的中文。
 *
 * @param path 当前路由路径
 * @param metaTitle 路由 meta.title，仅在没有三语文案时兜底
 */
export function applyRouteDocumentTitle(path: string, metaTitle?: unknown): void {
  // 报名页自己按当前语言写 Enroll / 报名 / Daftar，守卫不要覆盖
  if (path === "/training/enroll") return;
  const locale = useLocaleStore().locale;
  const titleKey = titleKeyForPath(path);
  const pageTitle = titleKey ? dict[titleKey][locale] : typeof metaTitle === "string" ? metaTitle : "";
  document.title = pageTitle ? `${pageTitle} · ${APP_BRAND_NAME}` : APP_BRAND_NAME;
}
